import React from "react";

const OrderSummery = ({ summery, newSummery }) => {
  return (
    <div className="w-full flex flex-col mt-6">
      <div className="w-full mb-5">
        <span className="text-textColor font-semibold  title1 text-base"
        >
          Order Summery
        </span>
      </div>
    <div className="bg-[#F6F7F3]  rounded-xl">
      <div className="p-4 flex flex-col gap-2">
        <div className="flex justify-between items-center  ">
          <span className="text-textcolor2 title1 text-[15px]">Product Price</span>
          <span className="title2 text-[15px] ">
            ₹{" "}
            {newSummery?.cart_summary?.mrp_price
              ? newSummery?.cart_summary?.mrp_price
              : summery?.mrp_price}
          </span>
        </div>
        <div className="flex justify-between items-center title1">
          <span className="text-textcolor2 title1 text-[15px]">Discount 15%</span>
          <span className="title2 text-[15px] ">
            - ₹{" "}
            {newSummery?.cart_summary?.discount_on_mrp
              ? newSummery?.cart_summary?.discount_on_mrp
              : summery?.discount_on_mrp}
          </span>
        </div>
        {newSummery?.cart_summary?.coupon_discount && (
          <div className="flex justify-between items-center">
            <span className="text-textcolor2 title1 text-[15px]">Couple Discount</span>
            <span className="title2 text-[15px] ">- ₹ {newSummery?.cart_summary?.coupon_discount}</span>
          </div>
        )}
       
        <div className="flex justify-between items-center title1">
          <span className="text-textcolor2 title1 text-[15px]">Packaging Charges</span>
          <span className="title2 text-[15px]">
            ₹{" "}
            {newSummery?.cart_summary?.packaging_charge
              ? newSummery?.cart_summary?.packaging_charge
              : summery?.packaging_charge}
          </span>
        </div>
        <div className="flex justify-between items-center title1">
          <span className="text-textcolor2 title1 text-[15px]">Tax</span>
          <span className="title2 text-[15px] ">
            ₹{" "}
            {newSummery?.cart_summary?.tax
              ? newSummery?.cart_summary?.tax
              : summery?.tax}
          </span>
        </div>
      </div>
      <div className="p-4 bg-[#DCE5D6] text-xl text-white rounded-b-xl">
        <div className="flex justify-between items-center">
          <span className=" font-bold text-textColor">Total</span>
          <span className="font-bold text-textColor text-2xl">
            ₹{" "}
            {newSummery?.cart_summary?.total
              ? Math.floor(newSummery.cart_summary.total * 100) / 100
              : Math.floor((summery?.total || 0) * 100) / 100}
          </span>
        </div>
      </div>
    </div>
    </div>
  );
};

export default OrderSummery;
